import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface PageBackProps {
  onClick: () => void;
  /** Defaults to "Back": it goes to the page before, which is not always the same one. */
  children?: React.ReactNode;
}

/** The way back from a page of its own: a chevron and a word, no box. One pattern for every such page. */
const PageBack: React.FC<PageBackProps> = ({ onClick, children = 'Back' }) => (
  <button type="button" className="c3-pageback" onClick={onClick}>
    <ChevronLeft size={16} strokeWidth={1.5} aria-hidden />
    {children}
  </button>
);

export default PageBack;
